import React from 'react';
import MainPage from './ui';

function App() {
    return (
        <MainPage />
    );
}

export default App;
